export const HOURS_OF_OPERATION_SETTINGS_KEYS = {
  HOURLY_REVENUE_CLOSE_THRESHOLD: 'hourly_revenue_close_threshold',
  VARY_HOURS_OF_OPERATION_BY: 'vary_hours_of_operation_by',
  BASE_RECOMMENDATIONS_ON: 'base_recommendations_on',
};

export const BASE_RECOMMENDATIONS = {
  FORECAST_AVG: 'forecast_avg',
  LAST_4_WEEKS_AVG: 'last_4_weeks_avg',
  STLY_AVG: 'stly_avg',
};

export const BASE_RECOMMENDATIONS_LABELS = {
  [BASE_RECOMMENDATIONS.FORECAST_AVG]: 'Forecasted Revenue',
  [BASE_RECOMMENDATIONS.LAST_4_WEEKS_AVG]: 'Last 4 Weeks Avg Revenue',
  [BASE_RECOMMENDATIONS.STLY_AVG]: 'STLY Avg Revenue',
};

export const DAY_OF_WEEK_VARIATION = 'day_of_week';
export const NO_VARIATION = 'none';

export const HOURS_OF_OPERATION_VARIATION_OPTION_KEYS = [DAY_OF_WEEK_VARIATION, NO_VARIATION];

export const HOURS_OF_OPERATION_VARIATION_LABELS = {
  [DAY_OF_WEEK_VARIATION]: 'Day of week',
  [NO_VARIATION]: 'Do not vary',
};

export const HOURS_OF_OPERATION_VARIATION_OPTIONS = [
  { value: DAY_OF_WEEK_VARIATION, label: HOURS_OF_OPERATION_VARIATION_LABELS[DAY_OF_WEEK_VARIATION] },
  { value: NO_VARIATION, label: HOURS_OF_OPERATION_VARIATION_LABELS[NO_VARIATION] },
];

export const DEFAULT_HOURS_SETTINGS = {
  [HOURS_OF_OPERATION_SETTINGS_KEYS.HOURLY_REVENUE_CLOSE_THRESHOLD]: 100,
  [HOURS_OF_OPERATION_SETTINGS_KEYS.VARY_HOURS_OF_OPERATION_BY]: DAY_OF_WEEK_VARIATION,
  [HOURS_OF_OPERATION_SETTINGS_KEYS.BASE_RECOMMENDATIONS_ON]: BASE_RECOMMENDATIONS.FORECAST_AVG,
};

export const CURRENT_HOURS_COMPARISON = 'current_hours';
export const RECOMMENDED_HOURS_COMPARISON = 'recommended_hours';

export const HOURS_COMPARISON_OPTIONS = [
  { value: CURRENT_HOURS_COMPARISON, label: 'Current Hours' },
  { value: RECOMMENDED_HOURS_COMPARISON, label: 'RoverRecs' },
];

export const NUMBER_OF_VISIBLE_HOURS = 8;
export const MAX_NEXT_DAY_HOUR_INDEX = 4; // Show up to '04:00' of the next day
export const MAX_HOUR_OFFSET = 21;
